import { render, staticRenderFns } from "./DocumentsTrackingControl.vue?vue&type=template&id=4ad22e42"
import script from "./DocumentsTrackingControl.vue?vue&type=script&lang=js"
export * from "./DocumentsTrackingControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports